// 2-letter monospace category tag — never colored.
// Mirrors gastos-v2/primitives.jsx CategoryMark.
//
// Production stores expense categories as label strings (e.g. "Insumos",
// "Renta") rather than the mockup's snake_case ids. We map both forms
// to a deterministic 2-letter code so the visual chrome stays stable.
'use client';

const CODES: Record<string, string> = {
  // Mockup ids
  insumos: 'IN',
  productos: 'PR',
  arrendamiento: 'AR',
  servicios: 'SV',
  software: 'SW',
  comisiones: 'CO',
  otros: 'OT',
  // Production labels (legacy)
  renta: 'AR',
  nómina: 'NO',
  nomina: 'NO',
  marketing: 'MK',
  equipo: 'EQ',
  otro: 'OT',
};

function codeFor(category: string | null | undefined): string {
  if (!category) return 'OT';
  const k = category.toString().trim().toLowerCase();
  if (CODES[k]) return CODES[k];
  // Fallback: first letter + (last consonant or last letter), uppercased.
  const cleaned = k.replace(/[^a-záéíóúüñ]/g, '');
  if (!cleaned) return 'OT';
  const first = cleaned[0];
  const last = cleaned[cleaned.length - 1] || first;
  return (first + last).toUpperCase();
}

export function CategoryMark({
  category,
  title,
}: {
  category: string | null | undefined;
  /** Optional tooltip label (full category name). */
  title?: string;
}) {
  const code = codeFor(category);
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '22px',
        height: '18px',
        borderRadius: '3px',
        fontFamily: 'var(--font-mono)',
        fontSize: '10.5px',
        letterSpacing: '0.4px',
        color: 'var(--ink-3)',
        background: 'var(--surface-2)',
        flexShrink: 0,
      }}
      title={title || category || undefined}
    >
      {code}
    </span>
  );
}
